import axios, { type AxiosError } from "axios";

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "/",
  timeout: 15000,
  headers: {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
  withCredentials: true,
});

export function isApiError(
  e: unknown
): e is AxiosError<{ error?: string }> {
  return axios.isAxiosError(e);
}

export function apiErrorMessage(e: unknown, fallback = "Ошибка"): string {
  if (isApiError(e)) {
    const data = e.response?.data as { error?: string } | undefined;
    return data?.error || e.message || fallback;
  }
  if (e instanceof Error) return e.message;
  return fallback;
}
